export const DEFAULT_LISTING_CARD_SIZES = [
  '(max-width: 549px) 100vw',
  '(max-width: 767px) 50vw',
  `(max-width: 1439px) 26vw`,
  `(max-width: 1920px) 18vw`,
  `14vw`,
].join(', ');
export const LISTING_TYPES = {
  PRODUCTS: 'products',
  STORES: 'stores',
  SERVICES: 'services',
};

export const ENUMS = {
  STORE_CATEGORY: 'storeCategory',
  SERVICE_CATEGORY: 'serviceCategories',
  PRODUCT_CATEGORY: 'productCategory',
  CONDITION: 'condition',
  COLOR: 'color',
  STRIPE: 'stripe',
  PAYPAL: 'paypal',
};

export const InboxPageTabs = Object.freeze({
  SALES: 'sales',
  ORDERS: 'orders',
});

export const USER_TYPES = {
  BUYER: 'buyer',
  SELLER: 'seller',
};
export const DAYS_ARR = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const DeliveryMethod = Object.freeze({
  PICKUP: 'pickup',
  SHIPPING: 'ownShipping',
});

export const RESPONSE = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

export const OWN = 'own';
export const FREE = 'free';
export const SHIPPING = 'ownShipping';
export const SB_SHIPPING = 'sbShipping';

export const SB_MARKET = 'SB Market';

export const CHECKOUT_STEPS = {
  SHIPPING_DETAILS: 'shippingDetails',
  CARRIERS: 'carriers',
  PAYMENT_DETAILS: 'paymentDetails',
  STRIPE: 'stripe',
  INQUERY: 'inquery',
};

export const PayoutMethod = Object.freeze({
  STRIPE: 'stripe',
});

export const StatusCode = Object.freeze({
  SUCCESS: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
  TOO_MANY_REQUESTS: 429,
});

export const SHIPPING_PREFERENCE = 'shippingPreference';

export const SHIPPO_TRACKING_STATUSES = {
  PRE_TRANSIT: 'information_received',
  PACKAGE_ACCEPTED: 'package_accepted',
  PACKAGE_ARRIVED: 'package_arrived',
  PACKAGE_DEPARTED: 'package_departed',
  PACKAGE_PROCESSING: 'package_processing',
  OUT_FOR_DELIVERY: 'outfordelivery',
  DELIVERED: 'delivered',
  UNKNOWN: 'other',
  DELAYED: 'delayed',
  CONTACT_CARRIER: 'contact_carrier',
};

export const TRACKING_DATE_FORMAT = 'Do MMMM YYYY, h:mm a';

export const ListingFieldConfigKey = Object.freeze({
  UNIT_OF_MEASUREMENT: 'unit_of_measurement',
  CONDITION: 'condition',
  COLOR: 'color',
  BRAND: 'brand',
  SIZE: 'size',
  POINTE: 'pointe',
  GENRE: 'genre',
  OF: 'of',
});

export const unitsOfMeasurement = ['oz', 'lb', 'g', 'kg'];
